export function buildQueryString(request: Record<string, any>, baseUrl: string = '', locale?: string): string {
    const params = new URLSearchParams();

    if (locale) {
        request = { ...request, locale: locale };
    }
    if (!request) return baseUrl;

    Object.entries(request).forEach(([key, value]) => {
        if (value == null) return;
        if (Array.isArray(value) && value.length > 0) {
            value.forEach((item) => params.append(key, item));
        } else if (value.toString().trim() !== '') {
            params.append(key, value.toString());
        }
    });

    const queryString = params.toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}

export function mergeParamsToUrl(
    path: string,
    newParams: Record<string, any>,
    additionalParams?: Record<string, any>,
    locale?: string
): string {
    const merged: Record<string, any> = {};

    // Safely spread existing params (if any)
    Object.entries(additionalParams || {}).forEach(([key, value]) => {
        merged[key] = value;
    });

    // Override or add new ones
    Object.assign(merged, newParams);

    return buildQueryString(merged, path, locale);
}
